import { render } from "./TermsofServiceInfo1.vue?vue&type=template&id=5c61a119"
const script = {}

import exportComponent from "/codebuild/output/src3807180263/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/scan/salesnote/TermsofServiceInfo1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c61a119"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c61a119', __exports__)) {
    console.log('reload')
    api.reload('5c61a119', __exports__)
  }
  
  module.hot.accept("./TermsofServiceInfo1.vue?vue&type=template&id=5c61a119", () => {
    console.log('re-render')
    api.rerender('5c61a119', render)
  })

}


export default __exports__